import React from 'react';
import { AuthContext } from 'utils/context/AuthContext';

export const useUserAuth = () => {
  const context = React.useContext(AuthContext);

  if (context === undefined) {
    throw new Error('`useUserAuth` hook must be used within a `AuthContext` component');
  }
  return context;
};
